<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Listado de rutas</h3>
      </div>
    </div>
    <k-table
      @seleccionar="seleccionarRuta"
      :path="path"
      :createButton="false"
      :editButton="false"
      :deleteButton="false"
      :columns="[
        {
          display: 'Código',
          value: 'codigo',
        },
        {
          display: 'Sucursal',
          value: 'bodega.descripcion',
        },
        {
          display: 'Nombre',
          value: 'nombre',
        },
        {
          display: 'Recaudador',
          value: 'descripcion_recaudador',
        },
        {
          display: 'Creador',
          value: 'creador.nombre',
        },
        {
          display: 'Creación',
          value: 'created_at',
        },
        {
          display: 'Modificador',
          value: 'modificador.nombre',
        },
        {
          display: 'Modificación',
          value: 'updated_at',
        }
      ]"
    ></k-table>
    <div class="modal-buttons">
      <button type="button" @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      path: url + "/logistica/rutas",
    };
  },
  methods: {
    cerrar: function () {
      this.$emit("cerrar");
    },
    seleccionarRuta: function (ruta) {
      this.$emit("seleccionar", ruta);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/ListaRutas.vue